/*
  Where each role lives.

  One deployment serves three audiences — parents, gate officers and school
  admins — and the API already tells us which one signed in. Routing from the
  role rather than from which login form was used means a gate officer who lands
  on the staff login still ends up at the gate screen, not the admin dashboard
  they cannot use.
*/

export type AppArea = 'parent' | 'gate' | 'teacher' | 'admin';

export function areaForRole(role: string | undefined): AppArea | null {
  if (!role) return null;
  if (role === 'parent') return 'parent';
  if (role === 'gate_officer') return 'gate';
  if (role === 'teacher') return 'teacher';
  if (role === 'institution_admin' || role === 'super_admin') return 'admin';
  return null;
}

export const HOME_PATH: Record<AppArea, string> = {
  parent: '/parent',
  gate: '/gate',
  /* A teacher is sent to the board, which is what they look at during
     dismissal; they can also take their own classes' register. */
  teacher: '/dismissal',
  admin: '/dashboard',
};

/** Where to send someone after they sign in, given the role the API returned. */
export function homeForRole(role: string | undefined): string {
  const area = areaForRole(role);
  return area ? HOME_PATH[area] : '/';
}
